import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  open: "",
  class: "popup popup--small js-popup is-opened"
}
const _hoisted_2 = { class: "popup__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "popup__content" }
const _hoisted_6 = { class: "auth-steps js-auth-steps js-auth-step-1 is-active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showSignUpReportCustomerModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          class: "popup-overlay"
        }))
      : _createCommentVNode("", true),
    (_ctx.showSignUpReportCustomerModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("header", null, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('reports.sign_up_customer_header')), 1),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "popup__close js-popup-close",
                style: {"cursor":"pointer"}
              }, _hoisted_4)
            ])
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('reports.sign_up_customer_body')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}